import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getEnquiryHotelVenueList_action, getEnquiryHotelVenueDetails_action, insertUpdateOtherHotel_action, insertUpdateEnquiryHotelVenue_action, deleteEnquiryHotelVenue_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/travelAndHospitality_action'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Item } from "@hilla/react-components/Item.js";



class TravelAndHospitalityMasterList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            enquiryHotelVenueList: [],
            otherHotelList: [],
            deleteType: '',
        }
        this.handleAdd = this.handleAdd.bind(this);
    }

    componentDidMount() {
        this.getEnquiryHotelVenueList()
    }

    getEnquiryHotelVenueList() {
        this.setState({ isLoading: true })
        this.props.getEnquiryHotelVenueList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        enquiryHotelVenueList: data.data[0] || [],
                        otherHotelList: data.data[1] || [],
                        isLoading: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handleAdd(type) {
        this.props.navigate('/travelAndHospitalityMasterAU', { state: { HotelType: type, isAdd: true, EnquiryHotelVenueID: null, OtherHotelID: null } })
    }

    handleUpdate(type, item) {
        this.props.navigate('/travelAndHospitalityMasterAU', {
            state: {
                HotelType: type,
                isAdd: false,
                EnquiryHotelVenueID: type == 'EnquiryHotelVenue' ? item.EnquiryHotelVenueID : null,
                OtherHotelID: type == 'OtherHotel' ? item.OtherHotelID : null
            }
        })
    }

    deletePop(type, item) {
        this.setState({
            isOpen: true,
            EnquiryHotelVenueID: type == 'EnquiryHotelVenue' ? item.EnquiryHotelVenueID : null,
            OtherHotelID: type == 'OtherHotel' ? item.OtherHotelID : null
        })
    }

    deleteEnquiryHotelVenue() {
        this.setState({ isLoading: true })
        this.props.deleteEnquiryHotelVenue_action(this.state.EnquiryHotelVenueID, this.state.OtherHotelID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Record deleted successfully")
                    this.getEnquiryHotelVenueList()
                    this.setState({
                        isLoading: false,
                        isOpen: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, isOpen, enquiryHotelVenueList, otherHotelList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Security Services Master</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 px-0">
                                <div className="row m-0">
                                    <div>
                                        {/* Description inline editable table */}
                                        <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>
                                                Enquiry Hotel Venue List
                                            </h3>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" style={{ width: '50px' }}>Sr No.</th>
                                                        <th>Hotel Name</th>
                                                        <th>Single Occupancy (INR)</th>
                                                        <th>Double Occupancy (INR)</th>
                                                        <th>Single Occupancy (USD)</th>
                                                        <th>Double Occupancy (USD)</th>
                                                        <th className="text-center" style={{ width: '60px' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {enquiryHotelVenueList.length > 0 ? enquiryHotelVenueList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>{item.HotelName}</td>
                                                            <td>{item.SingleOccupancyInINR}</td>
                                                            <td>{item.DoubleOccupancyInINR}</td>
                                                            <td>{item.SingleOccupancyInUSD}</td>
                                                            <td>{item.DoubleOccupancyInUSD}</td>
                                                            <td className="text-center">
                                                                <i
                                                                    className="fa fa-pencil"
                                                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => this.handleUpdate('EnquiryHotelVenue', item)}
                                                                /> &nbsp;
                                                                <i
                                                                    className="fa fa-trash text-danger"
                                                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => this.deletePop('OtherHotel', item)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td className="text-center" colSpan={8}>No record found</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {otherHotelList.length == 0 &&
                                            <div className="d-flex justify-content-end mt-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua btn-sm"
                                                    onClick={() => this.handleAdd('EnquiryHotelVenue')}
                                                >
                                                    Add +
                                                </button>
                                            </div>
                                        }
                                    </div>

                                    <div className="mt-4">
                                        {/* Description inline editable table */}
                                        <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>
                                                Other Hotel
                                            </h3>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" style={{ width: '50px' }}>Sr No.</th>
                                                        <th>Hotel Name</th>
                                                        <th>Person Name</th>
                                                        <th>Mobile No.</th>
                                                        <th>Email</th>
                                                        <th className="text-center" style={{ width: '60px' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {otherHotelList.length > 0 ? otherHotelList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>{item.HotelName}</td>
                                                            <td>{item.PersonName || '-'}</td>
                                                            <td>{item.MobileNo || '-'}</td>
                                                            <td>{item.EmailId || '-'}</td>
                                                            <td className="text-center">
                                                                <i
                                                                    className="fa fa-pencil"
                                                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => this.handleUpdate('OtherHotel', item)}
                                                                /> &nbsp;
                                                                <i
                                                                    className="fa fa-trash text-danger"
                                                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => this.deletePop('OtherHotel', item)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td className="text-center" colSpan={8}>No record found</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {otherHotelList.length == 0 &&
                                            <div className="d-flex justify-content-end mt-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua btn-sm"
                                                    onClick={() => this.handleAdd('OtherHotel')}
                                                >
                                                    Add +
                                                </button>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua btn-sm"
                                        onClick={(e) => this.deleteEnquiryHotelVenue()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray btn-sm" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getEnquiryHotelVenueList_action, getEnquiryHotelVenueDetails_action, insertUpdateEnquiryHotelVenue_action, insertUpdateOtherHotel_action, deleteEnquiryHotelVenue_action })(TravelAndHospitalityMasterList));
